import React, { use } from 'react'

import { useInterview } from '@/react-query/interview/interview'
import { useChangeTranscriptLanguageIsPending } from '@/react-query/transcription/transcription'
import Card from '@/views/components/Card'
import { InterviewDataContext } from '@/views/screens/Interview/context'

import { ProcessedToolbox } from './ProcessedToolbox'
import { ToolboxActions } from './ToolboxActions'
import { ToolboxFileUploadProgress } from './ToolboxFileUploadProgress'

export const Toolbox = (): React.ReactElement | null => {
  const { file, isFileUploading, fileUploadProgress } =
    use(InterviewDataContext)
  const interview = useInterview().data
  const changeTranscriptLanguageIsPending =
    useChangeTranscriptLanguageIsPending()

  const isProcessing =
    isFileUploading ||
    interview?.isFullTranscriptGenerating ||
    changeTranscriptLanguageIsPending ||
    fileUploadProgress

  const hasTranscript = interview?.fullTranscript != null

  let content: React.ReactNode = null

  if (isProcessing) {
    content = <ToolboxFileUploadProgress />
  } else if (file) {
    content = <ProcessedToolbox />
  } else if (!hasTranscript) {
    content = <ToolboxActions />
  }

  if (!content) return null

  return (
    <Card className="mb-5 flex flex-col bg-[#ebebeb]">
      <div className="flex flex-row justify-start items-center p-5 flex-wrap rounded-[2.5rem] bg-[#F5F5F5] gap-y-3 relative">
        {content}
      </div>
    </Card>
  )
}
